import templateUrl from './print-screen.html';

export const printScreenComponent = {
	bindings: {
		type: '@'
	},
	
	templateUrl,

	controller: class PrintScreenComponent {
		printScreen() {
			let elem = document.getElementById("printThis");
			let domClone = elem.cloneNode(true);
			let $printSection = document.getElementById("printSection");

			if (!$printSection) {
				$printSection = document.createElement("div");
				$printSection.id = "printSection";
				document.body.appendChild($printSection);
			}

			$printSection.innerHTML = "";
			$printSection.appendChild(domClone);
			window.print();
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/print-screen/print-screen.component.js